
























// @ is an alias to /src
import { AloPlat, getDefaultAloPlat } from '@/models/alo/AloPlat'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {ItemPanier} from '@/models/alo/ItemPanier'
import { VuetifyConfirmObject } from 'node_modules/vuetify-confirm/types'
import { getDefaultAloArbo } from '@/models/alo/AloArbo'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'
import { AloBaseLg } from '@/models/alo/AloBaseLg'
import deepEqual from 'deep-equal'

@Component({
  name: 'MenuBreakfastSectionItem',  
  props: {  
    qtyAllowed:{
      type:Number,
      required:true,
      default:0
    },
    value:{
      type:Array,
      default: () => []
    }
  }
})
export default class MenuBreakfastSectionItem extends mixins(BasePlat) {    
  itemPanier:ItemPanier = new ItemPanier()
  value!:Array<ItemPanier>
  qtyAllowed!:number

  mounted() {
    this.resetItemPanier()  
  }  
  
  resetItemPanier(){
    this.itemPanier = this.value.find(p => p.plat.id == this.plat.id) || new ItemPanier({plat:this.plat,qty:0})
  }

  @Watch("plat")
  onPlatChange(){
    this.resetItemPanier()
  }

  get maxValue(){
    return this.qtyAllowed + this.itemPanier.qty
  }

  get qty() {
    return this.itemPanier.qty
  }

  get parfums(){
    //@ts-ignore
    return this.$gct(this.plat,(it)=>it.parfums||[])
  }

  @Watch("qty")
  onQtyChange(newValue:number, oldValue:number) {
    if(newValue == 0) {
      let index = -1
      while((index = this.value.findIndex(p => p.plat.id == this.plat.id)) > -1) {        
        this.value.splice(index,1)
      } 
    }
    else if(oldValue == 0 && newValue > 0) {        
      //regarde si on doit ajouter l'item
      if(this.value.findIndex(p => p.plat.id == this.plat.id) < 0) this.value.push(this.itemPanier)
    }
    if(this.parfums.length > 0) {
      //Met à jour le tableau des parfums selectionnés      
      if(!this.itemPanier.parfum) this.itemPanier.parfum = []
      //@ts-ignore
      if(this.itemPanier.parfum.length > newValue) this.itemPanier.parfum?.splice(newValue,this.itemPanier.parfum.length-newValue)
      //@ts-ignore
      else while(this.itemPanier.parfum.length < newValue) this.itemPanier.parfum?.push(this.parfums[0])      
    }
  }

  get isSelected(){
    return this.qty > 0
  }

  get platsDic(){    
    return this.$store.myGetters.platsDic
  }
  
  get showAllergene(){
    return this.$store.myGetters.showAllergene
  }

  changeOptionPlat() {    
    if(this.itemPanier.qty > 0){
      this.itemPanier.qty = 0
    }
    else {
      this.itemPanier.qty = 1
    }
  }

  changeParum(parfum:AloBaseLg,idx:number) {
    //@ts-ignore
    this.$set(this.itemPanier.parfum,idx,parfum)
  }

  isSelectedParfum(parfum:AloBaseLg,idx:number) {
    //@ts-ignore
    return deepEqual(parfum,this.itemPanier.parfum[idx])
  }

}
